import type { ReactNode } from "react";

// Renders a URL for display: strips the scheme and fades the `?branch=…` query
// so the route reads first and the branch context sits quietly behind it.
export function UrlDisplay({ url }: { url: string }): ReactNode {
  const display = url.replace(/^https?:\/\//, "");
  const branchMatch = display.match(/^(.*?)(\?branch=.*)$/);
  if (!branchMatch) return display;
  return (
    <>
      {branchMatch[1]}
      <span style={{ opacity: 0.4 }}>{branchMatch[2]}</span>
    </>
  );
}
